export enum enumDisplayPortal {

  'Cellphone Banking'= 1,
  'Internet Banking',
  'All'
}

export namespace enumDisplayPortal {
  export function values() {
    return Object.keys(enumDisplayPortal).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
